module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_3_5.c7140f26.png";